/* import __COLOCATED_TEMPLATE__ from './success-message.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();